import { Tag } from "antd";
import React from "react";

// "12", not "12.0", but keeps the half in "11.5". Half days count as 0.5.
const days = (value) => (Number.isInteger(value) ? value : value?.toFixed(1));

/**
 * Class rank and attendance for a progress card, as a row of tags.
 * Draws nothing when the card has neither: drafts are unranked, and a template
 * with no attendance period has no attendance.
 */
const ProgressCardStats = ({ card }) => {
  const attendance = card?.attendance;
  if (!card?.rank && !attendance) return null;

  return (
    <div className="flex flex-wrap gap-2 pb-4">
      {card?.rank ? (
        <Tag color="blue" className="text-sm">
          Rank {card.rank}
          {card.out_of ? ` of ${card.out_of}` : ""}
        </Tag>
      ) : null}
      {attendance ? (
        <>
          <Tag className="text-sm">
            Working days {days(attendance.total_days)}
          </Tag>
          <Tag className="text-sm">Present {days(attendance.present_days)}</Tag>
          <Tag className="text-sm">Absent {days(attendance.absent_days)}</Tag>
          <Tag className="text-sm">{attendance.percent}% attendance</Tag>
        </>
      ) : null}
    </div>
  );
};

export default ProgressCardStats;
